import { render, staticRenderFns } from "./SecurityGate.vue?vue&type=template&id=7629ee50"
import script from "./SecurityGate.vue?vue&type=script&lang=js"
export * from "./SecurityGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports